// extracted by mini-css-extract-plugin
export default {"input":"user-detail_input__AIRdL","largeSelect":"user-detail_largeSelect__qdts9","mediaButton":"user-detail_mediaButton__gTxLG"};